import React, { useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useHistory } from "react-router";

// Layouts
import Auth from "layouts/Auth.js";
import Index from "views/Index.js";

// components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views
import Dashboard from "views/admin/Dashboard.js";
// import Maps from "views/admin/Maps.js";
import Settings from "views/admin/Settings.js";
// import Tables from "views/admin/Tables.js";

// API
import { authCekLogin } from "views/auth/login/api/loginAPI";
// import { useSelector } from "react-redux";

export default function Admin() {
  const history = useHistory();

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [resultLogin, setResultLogin] = useState(null);
  const [errorsLogin, setErrorsLogin] = useState(null);

  // const userLogin = useSelector((state) => state.global.userLogin);

  // Cek Login
  useEffect(() => {
    authCekLogin()
      .then((response) => setResultLogin(response))
      .catch((err) => setErrorsLogin(err));
  }, []);

  // Check if Request Failed
  useEffect(() => {
    if (errorsLogin !== null) {
      console.error(errorsLogin.message);
    }
  }, [errorsLogin]);

  // Check if Request Success
  useEffect(() => {
    if (resultLogin !== null) {
      // console.log(resultLogin.data);
      if (resultLogin.data.success === true) {
        if (resultLogin.data.data.id_user !== null) {
          setIsLoggedIn(true);
        }
      } else {
        let numericArray = [];
        for (let err in resultLogin.data.errors) {
          numericArray.push(resultLogin.data.errors[err]);
        }
        numericArray.forEach((err) => {
          console.log(err);
        });
        setIsLoggedIn(false);
        history.push("/");
      }
    }
  }, [resultLogin, history]);

  if (isLoggedIn === false) {
    <Switch>
      <Route path="/auth" component={Auth} />
      <Route path="/" exact component={Index} />
      <Redirect from="*" to="/" />
    </Switch>;
  }

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full h-screen -m-24">
          <Switch>
            <Route path="/admin/dashboard" exact component={Dashboard} />
            {/* <Route path="/admin/maps" exact component={Maps} /> */}
            <Route path="/admin/settings" exact component={Settings} />
            {/* <Route path="/admin/tables" exact component={Tables} /> */}
            <Redirect from="/admin" to="/admin/settings" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
